import { Typography, Breadcrumb } from 'antd'
import { EditableTable } from '@/components/EditableTable'
import type { ColumnConfig, ChangeSet } from '@/components/EditableTable/types'
import { useServices, useUpdateService, useCreateService, useDeleteService } from '@/hooks/useRefs'

const { Title } = Typography

export default function ServicesPage() {
  const { data: services, isLoading, refetch } = useServices()
  const updateMutation = useUpdateService()
  const createMutation = useCreateService()
  const deleteMutation = useDeleteService()

  const columns: ColumnConfig[] = [
    {
      field: 'serv_code',
      title: 'Код',
      type: 'text',
      editable: false,
      width: 80,
    },
    {
      field: 'serv_name',
      title: 'Название службы',
      type: 'text',
      editable: true,
      validation: { required: true },
    },
    {
      field: 'description',
      title: 'Описание',
      type: 'text',
      editable: true,
    },
  ]

  const handleSave = async (changes: ChangeSet) => {
    // Удаление
    if (changes.deleted) {
      for (const serv_code of changes.deleted) {
        await deleteMutation.mutateAsync(Number(serv_code))
      }
    }

    // Создание новых записей
    if (changes.created) {
      for (const row of changes.created) {
        if (row.serv_name) {
          await createMutation.mutateAsync({
            serv_name: String(row.serv_name),
            description: row.description ? String(row.description) : undefined,
          })
        }
      }
    }

    // Обновление существующих
    if (changes.updated) {
      for (const [serv_code, data] of Object.entries(changes.updated)) {
        await updateMutation.mutateAsync({
          serv_code: Number(serv_code),
          data: {
            serv_name: data.serv_name ? String(data.serv_name) : undefined,
            description: data.description ? String(data.description) : undefined,
          },
        })
      }
    }

    refetch()
  }

  return (
    <div>
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>Справочники</Breadcrumb.Item>
        <Breadcrumb.Item>Службы</Breadcrumb.Item>
      </Breadcrumb>

      <Title level={2}>Службы</Title>

      <EditableTable
        columns={columns}
        dataSource={services || []}
        rowKey="serv_code"
        loading={isLoading}
        onSave={handleSave}
        draftKey="services"
        allowAdd={true}
        allowPaste={true}
      />
    </div>
  )
}
